<script setup lang="ts">
import '@/styles';
import { useHead } from '@unhead/vue';
import { computed } from 'vue';

import { ComponentError } from '@/core/component-error';

const props = defineProps<{ error?: unknown }>();

useHead({
  titleTemplate: (title) => (title ? title + ' - ' : '') + $t`Castalian Spring`,
});

const err = computed(() =>
  props.error instanceof ComponentError ? props.error.err : props.error,
);

function isError(value: unknown): value is Error {
  return value instanceof Error;
}
</script>

<template>
  <h1>Error</h1>

  <template v-if="err">
    <template v-if="isError(err)">
      <p>{{ err.message }}</p>
      <pre v-if="err.stack">{{ err.stack }}</pre>
    </template>

    <pre v-else>{{ JSON.stringify(err, undefined, '\t') }}</pre>
  </template>
</template>
